import { render, staticRenderFns } from "./VuesticTagGroup.vue?vue&type=template&id=2a409643"
import script from "./VuesticTagGroup.vue?vue&type=script&lang=js"
export * from "./VuesticTagGroup.vue?vue&type=script&lang=js"
import style0 from "./VuesticTagGroup.vue?vue&type=style&index=0&id=2a409643&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pagsmile/front-end/pagsmile-dashboard/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a409643')) {
      api.createRecord('2a409643', component.options)
    } else {
      api.reload('2a409643', component.options)
    }
    module.hot.accept("./VuesticTagGroup.vue?vue&type=template&id=2a409643", function () {
      api.rerender('2a409643', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vuestic-theme/vuestic-components/vuestic-tag/VuesticTagGroup.vue"
export default component.exports